import { cn } from '../../lib/cn';

type Kpi = { id: string; label: string; value: string; change: string };

type Props = {
  kpis: Kpi[];
  className?: string;
};

function changeColor(change: string): string {
  if (change.startsWith('+') || change === 'ok') return 'text-success-600 dark:text-success-400';
  if (change.startsWith('-')) return 'text-error-600 dark:text-error-400';
  return 'text-slate-500';
}

export function ExecutiveKpiStrip({ kpis, className }: Props) {
  return (
    <div className={cn('flex gap-3 overflow-x-auto pb-2', className)} role="list" aria-label="Executive KPIs">
      {kpis.map((k) => (
        <div
          key={k.id}
          role="listitem"
          className="min-w-[120px] shrink-0 rounded-lg border border-slate-200 bg-white p-3 dark:border-slate-700 dark:bg-slate-900"
        >
          <p className="text-xs text-slate-500">{k.label}</p>
          <p className="mt-1 text-lg font-semibold text-slate-900 dark:text-slate-100">{k.value}</p>
          <p className={cn('text-xs font-medium', changeColor(k.change))}>{k.change}</p>
        </div>
      ))}
    </div>
  );
}
